import { render, staticRenderFns } from "./domesticInsurance.vue?vue&type=template&id=1a571111&"
import script from "./domesticInsurance.vue?vue&type=script&lang=js&"
export * from "./domesticInsurance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports